import { render, staticRenderFns } from "./List.vue?vue&type=template&id=8efb930e"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8efb930e')) {
      api.createRecord('8efb930e', component.options)
    } else {
      api.reload('8efb930e', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=8efb930e", function () {
      api.rerender('8efb930e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messaging/List.vue"
export default component.exports